import React from "react";
import PropTypes from "prop-types";

import Tooltip from "core/Tooltip";
import SrOnly from "core/SrOnly";
import RotateLeft from "core/ReusableIcons/RotateLeft";
import RotateRight from "core/ReusableIcons/RotateRight";

import { RotateIconButton } from "./styles";

import { useIconEditorDispatch } from "js/contexts/IconEditorContext";

import { convertPxToRem } from "frontend/components/helpers";

const EditorRotate = ({ direction, iconId }) => {
    const dispatch = useIconEditorDispatch();

    const rotateIcon = () => {
        let actionType;

        if (direction === "cw") actionType = "ROTATE_CW";
        if (direction === "ccw") actionType = "ROTATE_CCW";

        dispatch({
            type: actionType,
            iconId
        });
    };

    const getTooltipText = () => {
        if (direction === "cw") return "Rotate Clockwise";
        if (direction === "ccw") return "Rotate Counterclockwise";
    };

    return (
        <Tooltip message={getTooltipText()} size="small">
            <RotateIconButton
                svgElementType={direction === "ccw" ? RotateLeft : RotateRight}
                width={convertPxToRem({ px: 16 })}
                buttonProps={{ onClick: rotateIcon }}
                styleType="secondary"
            />
            <SrOnly>
                {`Rotate icon 15 degrees ${
                    direction === "ccw" ? `counterclockwise` : `clockwise`
                }`}
            </SrOnly>
        </Tooltip>
    );
};

EditorRotate.propTypes = {
    direction: PropTypes.oneOf(["ccw", "cw"]),
    iconId: PropTypes.string
};

export default React.memo(EditorRotate);
